import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFocusZoomIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"focus-zoom-in"} maskId="square-filled-radius-0-stroke-1-IconFocusZoomIn"><path d="M8.5 3H3V8.5H4V4H8.5V3Z" fill="currentColor"/><path d="M21 3H15.5V4H20V8.5H21V3Z" fill="currentColor"/><path d="M4 20V15.5H3V21H8.5V20H4Z" fill="currentColor"/><path d="M21 21V15.5H20V20H15.5V21H21Z" fill="currentColor"/><path d="M16 11.5H8V12.5H16V11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFocusZoomIn;
